<template>
<button class="btn" @click="$emit('click', $event)">
  <slot />
</button>
</template>

<script>
export default {

}
</script>
